export default __webpack_public_path__ + "static/media/Phone.36baa0ad.svg";